import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';
import { useState } from 'react';

import { FormattedMessage } from '@flipster/i18n';
import { Tooltip } from '@flipster/react/design-system-legacy/tooltip';
import { IconButton } from '@flipster/react/design-system/icon-button';
import PipIcon from '@flipster/react/icon/generated/PipIcon';
import { useMounted } from '@flipster/react/misc/lifecycle/mount';
import segment from '@flipster/utils/segment';
import { PipEvent } from '@flipster/utils/segment/events/pip';
import { checkMobile } from '@flipster/utils/user-agent';

import { pipModeConfigBunja } from '@web/app/[locale]/(web)/_pip/bunja';
import { PipPortal, pip } from '@web/app/[locale]/(web)/_pip/pip';
import { tradeSymbolBunja } from '@web/app/[locale]/(web)/trade/_misc/symbol';

import TradePip from '../trade-pip';

export const PipButton = () => {
  const { pipModeConfigAtom } = useBunja(pipModeConfigBunja);
  const pipModeConfig = useAtomValue(pipModeConfigAtom);
  const { symbol } = useBunja(tradeSymbolBunja);
  const [pipEnabledTs, setPipEnabledTs] = useState<string | null>(null);

  const isMounted = useMounted();
  const isMobile = checkMobile();

  if (!isMounted || isMobile) return null;
  return (
    <>
      <Tooltip placement='bottom'>
        <Tooltip.Trigger asChild>
          <IconButton
            hierarchy='tertiary'
            size='small'
            icon={<PipIcon />}
            css={{ rounded: 4 }}
            onClick={() => pip.open({ width: 320, height: 400 })}
          />
        </Tooltip.Trigger>
        <Tooltip.Content portal>
          <FormattedMessage id='Autogen_common.r251126.s_Picture_in_picture' />
        </Tooltip.Content>
      </Tooltip>
      <PipPortal
        autoPipOnVisibilityChange={pipModeConfig}
        onPipOpen={() => {
          segment.track(PipEvent.PipModeEnabled, { symbol });
          setPipEnabledTs(new Date().toISOString());
        }}
        onPipClose={() => {
          segment.track(PipEvent.PipModeExit, { symbol, pip_enabled_ts: pipEnabledTs ?? '' });
          setPipEnabledTs(null);
        }}
      >
        <TradePip symbol={symbol} />
      </PipPortal>
    </>
  );
};
